import { listPosition } from "../index";
import * as mainStyles from "../assets/css/main.css";

export function getCloseBtn() {
    let btn = document.createElement("button");
    btn.className = "leaflet-menu-close-button sl-ic-1-chevron-left";
    btn.setAttribute("aria-label", "Close store list");
    btn.addEventListener("click", () => {
        closeLocationsList();
    });
    return btn;
}

export function closeLocationsList() {
    let menu = document.getElementsByClassName(mainStyles.menu)[0];
    if (menu && (listPosition == 0 || listPosition == 3)) {
        menu.style.display = "none";
    }
}